import React from "react";
import { SourceTypeEnum } from "../../../api/models/source-type-enum";
import { useSourceListItem } from "./SourceListItemHook";
import { openFileExcel } from "../../../utils/helpers/OpenDocumentHelper";
import { SourceListItem } from "../../interfaces/SourceListItemObj";

export interface SourceListItemProps {
  source: string;
  obj: SourceListItem;
}
export const SourceListItemView: React.FunctionComponent<SourceListItemProps> = (props) => {
  const { classNames } = useSourceListItem();

  const RenderIcon = () => {
    if (SourceTypeEnum.TAGETIK === props.source)
      return <img src={"/assets/db-1x.png"} alt={"Database Icon"} className={classNames.icon} />;
    else return <img src={"/assets/excel-1x.png"} alt={"Excel Icon"} className={classNames.icon} />;
  };
  return (
    <div className={classNames.item}>
      <RenderIcon />
      {SourceTypeEnum.TAGETIK === props.source ? (
        <div className={classNames.fontName}>{props.obj.desc}</div>
      ) : (
        <div className={classNames.attachment} onClick={() => openFileExcel(props.obj.cod)}>
          {props.obj.desc}
        </div>
      )}
    </div>
  );
};
